<div class="filters-row mt-4 mb-2">
  <div class="row">
    <div class="col-12 col-lg-5" [formGroup]="form">
      <div class="row g-2">
        <div class="col-6">
          <app-material-input-datepicker
            [cssClass]="'mb-0'"
            formControlName="date_from">
          </app-material-input-datepicker>
        </div>

        <div class="col-6">
          <app-material-input-datepicker
            [cssClass]="'mb-0'"
            formControlName="date_to">
          </app-material-input-datepicker>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-7 mt-3 mt-lg-0">
      <div class="form__group">
        <div class="form__input mb-0">
          <input
            class="input"
            type="text"
            placeholder="Поиск"
            [(ngModel)]="searchValue">

          <div class="form__input_icon icon icon_Small_Search c-pointer"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12 filters-total">
      Всего: <b>{{ count }}</b>
    </div>
  </div>
</div>
<div class="material-datatable-wrapper">
  <div class="table-responsive">
    <table class="table">
      <tr>
        @for (el of head; track el) {
          <th [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
            <div [formGroup]="form">
              <div class="row no-gutters align-items-center flex-nowrap" [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
                <div class="col table__input">
                  @if (el.input) {
                    <app-material-input
                      [placeholder] = "el.caption"
                      [formControlName] = "el.name"
                      [cssClass]="'mb-0'">
                    </app-material-input>
                  }
                  @if (el.select) {
                    <app-material-select
                      [formControlName]="el.name"
                      [cssClass]="'mb-0'"
                      [placeholder]="el.caption"
                      >
                      @for (opt of el.select; track opt) {
                        <option [value]="opt.id">{{opt.caption}}</option>
                      }
                    </app-material-select>
                  }
                  @if (!el.input && !el.select) {
                    {{el.caption}}
                  }
                </div>
                @if (el.sort) {
                  <div class="col-auto">
                    <a href="javascript:void(0)" (click)="sortChange(el.name)">
                    <i class="icon" [ngClass]="{'icon_new-sort-none': true == !sort[el.name],
                                      'icon_new-sort-down': 'asc' == sort[el.name],
                                      'icon_new-sort-up': 'desc' == sort[el.name]}"></i>
                    </a>
                  </div>
                }
              </div>
            </div>
          </th>
        }
      </tr>
      @if (rows && rows.length === 0) {
        <tr>
          <td [attr.colspan]="head.length">
            <div class="py-2">
              Записи отсутствуют.
            </div>
          </td>
        </tr>
      }
      @for (row of rows; track row; let row_index = $index) {
        <tr>
          <td>
            <span>{{row['date']}} {{row['time_from']}}-{{row['time_to']}}</span>
          </td>
          <td>
            @if (row['action'] === 'publish') {
              <span>Опубликован на витрину</span>
            }
            @if (row['action'] === 'unpublish') {
              <span>Снят с витрины</span>
            }
          </td>
          <td>
            <a [routerLink]="['/entity/edit/', row['developer_id']]">{{row['developer_caption']}}</a>
          </td>
          <td>
            <a [routerLink]="['/housing2/complex/', row['complex_id']]">{{row['complex_caption']}}</a>
          </td>
          <td>
            @if (row['has_flat_changes']) {
              <a href="javascript: void(0)" (click)="viewDetailInfo(row, $event)">
                Подробнее
              </a>
            }
          </td>
        </tr>
      }
    </table>
  </div>
</div>

@if (modalShow) {
  <app-modal [caption]="modalCaption" (onClosed)="modalClose()">
    <h3>Корпусы:</h3>

    @if (modalLoading) {
      <div class="d-flex justify-content-center py-4">
        <div class="text-center c-dark-grey">Загрузка <i class="fa fa-spinner fa-spin"></i></div>
      </div>
    }

    @if (modalError) {
      <div class="alert alert-danger d-flex justify-content-between align-items-center">
        <span>Не удалось загрузить квартиры.</span>
      </div>
    }

    @if (!modalLoading && !modalError) {
      @if (modalContent.length === 0) {
        <div class="py-2">Изменений по квартирам не найдено.</div>
      } @else {
        <app-tab-wrapper [tabClass]="'xs-width-33'" [cssClass]="'mobile-tabs-scroll'">
          @for (house of modalContent; track house) {
            <app-tab-element [caption]="house['caption']">
              <a [routerLink]="['/housing2/house/', house['id']]">Ссылка на корпус</a>
              <div class="material-datatable-wrapper">
                <div class="table-responsive">
                  <table class="table">
                    <tr>
                      @for (mh of modalHead; track mh) {
                        <th>
                          <div class="row no-gutters align-items-center flex-nowrap">
                            <div class="col table__input">
                              {{mh.caption}}
                            </div>
                          </div>
                        </th>
                      }
                    </tr>
                    @for (flat of house['flats']; track flat) {
                      <tr>
                        <td>{{flat['datetime']}}</td>
                        <td>{{flat['section_caption']}}</td>
                        <td>{{flat['floor_caption']}}</td>
                        <td>{{flat['caption']}}</td>
                        <td>
                          @if (flat['action'] === 'publish') { <span>Добавлена</span> }
                          @if (flat['action'] === 'unpublish') { <span>Убрана</span> }
                        </td>
                      </tr>
                    }
                  </table>
                </div>
              </div>
            </app-tab-element>
          }
        </app-tab-wrapper>
      }
    }
  </app-modal>
}

<div class="alt-pagination">
  <app-paginator
    [queryParams]="filterColumns"
    [itemsPerPage]="50"
    [itemCount]="count"
    [currentPage]="currentPage"
    [baseUrl]="'/realty-showcase-items/'">
  </app-paginator>
</div>
